/**
 * Domain enums shared between API, worker and web.
 *
 * These mirror the Prisma enums exactly. They are re-declared here (rather
 * than imported from @musleempay/database) so the browser bundle never pulls
 * in the Prisma client.
 */
export const USER_STATUSES = ['PENDING', 'ACTIVE', 'SUSPENDED', 'DEACTIVATED'];
export const PLATFORM_ROLES = ['SUPER_ADMIN', 'MERCHANT_USER'];
/** Roles a user can hold within a single merchant. */
export const MERCHANT_ROLES = [
    'OWNER',
    'ADMIN',
    'MANAGER',
    'SALES',
    'FINANCE',
    'WAREHOUSE',
    'CUSTOMER_SERVICE',
];
export const MERCHANT_STATUSES = ['PENDING', 'ACTIVE', 'SUSPENDED', 'CLOSED'];
export const PRODUCT_STATUSES = ['DRAFT', 'ACTIVE', 'ARCHIVED'];
export const SALES_PAGE_STATUSES = ['DRAFT', 'PUBLISHED', 'UNPUBLISHED'];
/** Order lifecycle. See packages/shared/src/state/order-state.ts. */
export const ORDER_STATUSES = [
    'PENDING_PAYMENT',
    'PAID',
    'PROCESSING',
    'PACKED',
    'SHIPPED',
    'COMPLETED',
    'CANCELLED',
    'REFUNDED',
];
export const FULFILLMENT_STATUSES = [
    'UNFULFILLED',
    'PARTIALLY_FULFILLED',
    'FULFILLED',
    'RETURNED',
];
/** Payment lifecycle. See packages/shared/src/state/payment-state.ts. */
export const PAYMENT_STATUSES = [
    'PENDING',
    'PROCESSING',
    'SUCCESS',
    'FAILED',
    'CANCELLED',
    'EXPIRED',
    'REFUNDED',
    'PARTIALLY_REFUNDED',
];
export const PAYMENT_METHODS = [
    'FPX',
    'CARD',
    'EWALLET',
    'BANK_TRANSFER',
    'CASH_ON_DELIVERY',
    'MOCK',
];
export const COUPON_TYPES = ['PERCENTAGE', 'FIXED_AMOUNT', 'FREE_SHIPPING'];
export const INVOICE_STATUSES = ['DRAFT', 'ISSUED', 'PAID', 'VOID'];
export const SHIPMENT_STATUSES = [
    'PENDING',
    'IN_TRANSIT',
    'DELIVERED',
    'FAILED',
    'RETURNED',
];
export const NOTIFICATION_CHANNELS = ['EMAIL', 'IN_APP'];
export const NOTIFICATION_STATUSES = ['QUEUED', 'SENT', 'FAILED', 'READ'];
export const STAFF_INVITATION_STATUSES = ['PENDING', 'ACCEPTED', 'REVOKED', 'EXPIRED'];
/** Derived customer segments (computed at query time, not stored). */
export const CUSTOMER_SEGMENTS = ['NEW', 'REPEAT', 'VIP', 'INACTIVE'];
//# sourceMappingURL=enums.js.map